<template>
	<div class="m-channel-banner" :style="{'height': height}">
		<div v-for="(item, i) in bannerList" :key="i" class="item" :class="{'z-crt': i == currentBanner}">
			<a>
				<c-image class="image" :src="item.img_url" mode="aspectFill" :style="{'height': height}"></c-image>
			</a>
		</div>
		
		<div v-if="bannerList.list && bannerList.list.length > 1" class="nav">
			<div v-for="(item, i) in bannerList" :key="i" class="item" :class="{'z-crt': i == currentBanner}"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				currentBanner: 0,
				bannerList: []
			}
		},
		
		computed: {
			height() {
				if (this.bannerList && this.bannerList[0]) {
					return this.bannerList[0].img_height / 2 + 'px';
				}
				return '300px';
			}
		},
		
		mounted() {
		},
		
		methods: {
			set(data) {
				this.bannerList = data.list;
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-channel-banner {
		position: relative;
		overflow: hidden;
		
		> .item {
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
			text-align: center;
			opacity: 0;
			transition: opacity .3s ease;
			
			&.z-crt {
				z-index: 1;
				opacity: 1;
			}
			
			.image {
				position: relative;
				left: 50%;
				min-width: 1920px;
				transform: translate(-50%,0);
			}
		}
		
		.nav {
			z-index: 1;
			position: absolute;
			left: 50%;
			bottom: 8px;
			font-size: 0;
			transform: translate(-50%,0);
			
			.item {
				display: inline-block;
				width: 5px;
				height: 5px;
				border-radius: 3px;
				margin: 0 7px;
				background: #E9E9E9;
				
				&.z-crt {
					width: 20px;
				}
			}
		}
	}
</style>
